<template>
  <div>
    <v-container v-if="refreshJourneyColorBackground" class="fill-height pl-0 ml-0 text-center containerheight" fluid>
      <v-row align="left" >
        <v-col align="left" v-if="cacheJourney.backgroundColor">
          <strong>{{$t('BackgroundColor')}}</strong>
        </v-col>
        <v-col v-else align="left" class="red--text">
          <strong>{{$t('BackgroundColor')}}</strong>
        </v-col>
      </v-row>
      <v-row align="center" >
        <v-col cols=2>
        <v-btn @click="selectJourneyColorBackground(1)"  fab dark x-small color="colorPalettejourney1">
          <v-icon v-if="cacheJourney.backgroundColor==1" dark>
            mdi-check-bold
          </v-icon>
        </v-btn>
        </v-col>
        <v-col cols=2>
        <v-btn @click="selectJourneyColorBackground(2)"  fab dark x-small color="colorPalettejourney2">
          <v-icon v-if="cacheJourney.backgroundColor==2" dark>
            mdi-check-bold
          </v-icon>
        </v-btn>
        </v-col>
        <v-col cols=2>
        <v-btn @click="selectJourneyColorBackground(3)"  fab dark x-small color="colorPalettejourney3">
          <v-icon v-if="cacheJourney.backgroundColor==3" dark>
            mdi-check-bold
          </v-icon>
        </v-btn>
        </v-col>
        <v-col cols=2>
        <v-btn @click="selectJourneyColorBackground(4)"  fab dark x-small color="colorPalettejourney4">
          <v-icon v-if="cacheJourney.backgroundColor==4" dark>
            mdi-check-bold
          </v-icon>
        </v-btn>
        </v-col>
        <v-col cols=2>
        <v-btn @click="selectJourneyColorBackground(5)"  fab dark x-small color="colorPalettejourney5">
          <v-icon v-if="cacheJourney.backgroundColor==5" dark>
            mdi-check-bold
          </v-icon>
        </v-btn>
        </v-col>
        <v-col cols=2>
        <v-btn @click="selectJourneyColorBackground(6)" fab dark x-small color="colorPalettejourney6">
          <v-icon v-if="cacheJourney.backgroundColor==6" dark>
            mdi-check-bold
          </v-icon>
        </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
//this page is displayed when an error occurs

export default {
  name: 'selectJourneyBackgroundColor',
  components: {
  },
  data() {
    return {
      refreshJourneyColorBackground:true
    }

  },
    watch: {
  
    '$store.state.newJourney.backgroundColor': function () {
      this.refreshJourneyColorBackground=false
      this.refreshJourneyColorBackground=true
    }
  },
  computed: {
    getUser: {
      get: function () {
        return this.$store.getters.getUser;
      }
    },
    cacheJourney: {
      get: function () {
        return this.$store.getters.getNewJourneys
      }
    }

  },
  methods: {

    selectJourneyColorBackground(selectedcolor){
      this.refreshJourneyColorBackground=false
      this.$store.dispatch('setJourneyBackgroundColor', selectedcolor).then(()=>this.refreshJourneyColorBackground=true)
    }
  }
}
</script>
<style scoped>

</style>

